export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./table-nfe.vue?vue&type=template&id=c4490d2e&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/table-nfe.vue?vue&type=template&id=c4490d2e&scoped=true&
// module id = 272
// module chunks = 1